import React from "react";
import {
    Box,
    Divider,
    FormControl,
    IconButton,
    InputLabel,
    MenuItem,
    Select,
    Stack,
    Typography,
} from "@mui/material";
import { Refresh } from "@mui/icons-material";
import LogoutButton from "../../../components/LogoutButton";
import LanguageToggle from "../../../components/LanguageToggle/LanguageToggle";

export default function KitchenDashboardHeader({
    t,
    title,
    pendingOrdersCount,
    productionCenters,
    selectedCenterNames,
    onChangeCenterNames,
    onRefresh,
    isFetching,
}) {
    return (
        <>
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: 1,
                }}
            >
                <Box sx={{ minWidth: 0, flex: 1 }}>
                    <Typography
                        variant="h5"
                        sx={{ fontWeight: 900, lineHeight: 1.1 }}
                    >
                        {title}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                        {t("kds.pendingOrdersNotReady", {
                            count: pendingOrdersCount,
                        })}
                    </Typography>
                </Box>
                <Stack
                    direction={{ xs: "column", md: "row" }}
                    spacing={1}
                    alignItems={{ xs: "stretch", md: "center" }}
                    sx={{ minWidth: { xs: "100%", md: 320 }, flexShrink: 0 }}
                >
                    <FormControl size="small" sx={{ minWidth: { xs: "100%", md: 320 } }}>
                        <InputLabel id="kds-center-select-label">
                            {t("production.productionCenters")}
                        </InputLabel>
                        <Select
                            labelId="kds-center-select-label"
                            multiple
                            disabled={!productionCenters?.length}
                            value={selectedCenterNames}
                            label={t("production.productionCenters")}
                            onChange={(event) =>
                                onChangeCenterNames?.(event.target.value)
                            }
                            renderValue={(selected) =>
                                (selected || [])
                                    .map((value) => {
                                        const center = (productionCenters || []).find(
                                            (item) => item.name === value
                                        );
                                        return (
                                            center?.description ||
                                            center?.name ||
                                            value
                                        );
                                    })
                                    .join(", ")
                            }
                        >
                            {(productionCenters || []).map((center) => (
                                <MenuItem key={center.name} value={center.name}>
                                    {center.description || center.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <LanguageToggle />
                    <LogoutButton />
                    <IconButton onClick={onRefresh} disabled={isFetching}>
                        <Refresh />
                    </IconButton>
                </Stack>
            </Box>
            <Divider />
        </>
    );
}
